<template>
  <div>

    <div class="row mt-5">

      <div class="col-xl-3 col-md-6">
        <Payouts-Pending-MiniCard/>
      </div>

      <div class="col-xl-3 col-md-6">
        <Payouts-To-Submit-MiniCard/>
      </div>

      <div class="col-xl-3 col-md-6">
        <Payouts-Submitted-MiniCard/>
      </div>

      <div class="col-xl-3 col-md-6">
        <Payouts-Paid-MiniCard/>
      </div>

    </div>

    <el-tabs v-model="activeTab" @tab-click="updateRendering()">
      <el-tab-pane class="row" label="Invoices" name="Invoices">
        <Payouts-Card class="col-12"/>
      </el-tab-pane>
      <el-tab-pane class="row" label="Evolution" name="Evolution">
        <Payouts-Graph-Multi-View-Card v-show="$store.getters.companySelected == 0"
                                          class="col-md-8"
                                          title="Evolution of Payouts"
                                         :render="renderMulti"/>
        <Payouts-Pie-Chart-Multi-View-Card v-show="$store.getters.companySelected == 0"
                                              class="col-md-4 pr-3.1"
                                              title="Total Payouts"
                                             :render="renderMulti"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'Invoices',
  data () {
    return {
      activeTab: 'Invoices'
    }
  }
}
</script>

<style>

</style>